<template>
    <div>
        <a-modal
            :footer="null"
            closable
            maskClosable
            :width="500"
            :visible="isActive"
            :zIndex="81000"
            v-model="isActive"
            :wrapStyle="{ top: '-80px' }">
            
            <div class="flex flexitems-center">
                <div class="w-full">                    
                    <div slot:header>
                        <div class="vx-row w-full">
                            <h4 class="ml-4">FORMAS DE PAGAMENTO</h4>
                        </div>
                        <vs-divider class="shadow" />
                    </div>

                    <div class="vx-row w-full ">
                        <div class="w-2/12 mt-6 ml-4 -mr-2">
                            <vs-checkbox v-model="methods[0].selected" class="mt-2" size="large" />
                        </div>
                        <div class=" w-2/12 -ml-4" :class="{'notSelected' : !methods[0].selected}">
                            <img src="@/assets/images/payment/money_red.png" width="50" class="mt-4"  />
                        </div>
                        <div class=" w-5/12 lg:w-5/12 xl:5/12" :class="{'notSelected' : !methods[0].selected}">
                            <span class="w-full font-bold">DINHEIRO</span>
                            <currency-input 
                                :disabled="!methods[0].selected"
                                :distraction-free="{ hideCurrencySymbol : false }"
                                :auto-decimal-mode="true"
                                :currency="{prefix: 'R$ '}"
                                class="vs-inputx vs-input--input normal danger"
                                v-model="methods[0].value" />
                        </div>
                        <div class="w-1/12 mt-6 ml-4 mr-4" :class="{'notSelected' : !methods[0].selected}">
                            <VueInputCalculator enableKeyboard v-model.number="methods[0].value" v-if="methods[0].selected" :action-buttons-bg-color="'#ea5455'">
                                <a-icon type="calculator" class="text-5xl cursor-pointer" />
                            </VueInputCalculator>
                        </div>
                    </div>

                    <vs-divider border-style="dashed" class="shadow" />

                    <div class="vx-row w-full ">
                        <div class="w-2/12 mt-6 ml-4 -mr-2">
                            <vs-checkbox v-model="methods[1].selected" class="mt-2" size="large" />
                        </div>
                        <div class=" w-2/12 -ml-4" :class="{'notSelected' : !methods[1].selected}">
                            <img src="@/assets/images/payment/card_red.png" width="50" class="mt-2"  />
                        </div>
                        <div class=" w-5/12 lg:w-5/12 xl:5/12" :class="{'notSelected' : !methods[1].selected}">
                            <span class="w-full font-bold" v-if="windowWidth > 480">CARTÃO DE CRÉDITO</span>
                            <span class="w-full font-bold" v-else>CRÉDITO</span>
                            <currency-input 
                                :disabled="!methods[1].selected"
                                :distraction-free="{ hideCurrencySymbol : false }"
                                :auto-decimal-mode="true"
                                :currency="{prefix: 'R$ '}"
                                class="vs-inputx vs-input--input normal danger"
                                v-model="methods[1].value" />
                        </div>
                        <div class="w-1/12 mt-6 ml-4 mr-4" :class="{'notSelected' : !methods[1].selected}">
                            <VueInputCalculator enableKeyboard v-model.number="methods[1].value" v-if="methods[1].selected" :action-buttons-bg-color="'#ea5455'">
                                <a-icon type="calculator" class="text-5xl cursor-pointer" />
                            </VueInputCalculator>
                        </div>
                    </div>

                    <vs-divider border-style="dashed" class="shadow" />

                    <div class="vx-row w-full ">
                        <div class="w-2/12 mt-6 ml-4 -mr-2">
                            <vs-checkbox v-model="methods[2].selected" class="mt-2" size="large" />
                        </div>
                        <div class=" w-2/12 -ml-4" :class="{'notSelected' : !methods[2].selected}">
                            <img src="@/assets/images/payment/card_red.png" width="50" class="mt-2"  />
                        </div>
                        <div class=" w-5/12 lg:w-5/12 xl:5/12" :class="{'notSelected' : !methods[2].selected}">
                            <span class="w-full font-bold" v-if="windowWidth > 480">CARTÃO DE DÉBITO</span>
                            <span class="w-full font-bold" v-else>DÉBITO</span>
                            <currency-input 
                                :disabled="!methods[2].selected"
                                :distraction-free="{ hideCurrencySymbol : false }"
                                :auto-decimal-mode="true"
                                :currency="{prefix: 'R$ '}"
                                class="vs-inputx vs-input--input normal danger"
                                v-model="methods[2].value" />
                        </div>
                        <div class="w-1/12 mt-6 ml-4 mr-4" :class="{'notSelected' : !methods[2].selected}">
                            <VueInputCalculator enableKeyboard v-model.number="methods[2].value" v-if="methods[2].selected" :action-buttons-bg-color="'#ea5455'">
                                <a-icon type="calculator" class="text-5xl cursor-pointer" />
                            </VueInputCalculator>
                        </div>
                    </div>

                    <vs-divider border-style="dashed" class="shadow" />

                    <div class="vx-row w-full ">
                        <div class="w-2/12 mt-6 ml-4 -mr-2">
                            <vs-checkbox v-model="methods[3].selected" class="mt-2" size="large" />
                        </div>
                        <div class=" w-2/12 -ml-4" :class="{'notSelected' : !methods[3].selected}">
                            <img src="@/assets/images/payment/P.png" width="50" class="mt-4"  />
                        </div>
                        <div class=" w-5/12 lg:w-5/12 xl:5/12" :class="{'notSelected' : !methods[3].selected}">
                            <span class="w-full font-bold">PICPAY</span>
                            <currency-input 
                                :disabled="!methods[3].selected"
                                :distraction-free="{ hideCurrencySymbol : false }"
                                :auto-decimal-mode="true"
                                :currency="{prefix: 'R$ '}"
                                class="vs-inputx vs-input--input normal danger"
                                v-model="methods[3].value" />
                        </div>
                        
                        <div class="w-1/12 mt-6 ml-4 mr-4" :class="{'notSelected' : !methods[3].selected}">
                            <VueInputCalculator enableKeyboard v-model.number="methods[3].value" v-if="methods[3].selected" :action-buttons-bg-color="'#ea5455'">
                                <a-icon type="calculator" class="text-5xl cursor-pointer" />
                            </VueInputCalculator>
                        </div>
                    </div>

                    <vs-divider  class="mt-6 shadow">  </vs-divider>

                    <div class="vx-row w-full" v-if="transformedTaxes.length">
                        <div class="vx-col w-full">
                            <span class="w-full text-bold text-lg font-bold underline"> TAXAS: </span>
                            <div class="vx-row w-full mt-4" v-for="(tax, i) in transformedTaxes" :key="i">
                                <vs-switch class="ml-4" v-model="tax.enabled" />
                                <span class="ml-2" :class="{'line-through' : !tax.enabled}">
                                    {{ tax.description.toUpperCase() }} -
                                    {{ tax.calculatedValue | currency }}
                                    ({{ tax.transformedValue }})
                                </span>
                            </div>
                        </div>
                    </div>

                    <vs-divider border-style="dashed" class="mt-6 shadow" v-if="transformedTaxes.length">  </vs-divider>

                    <div class="vx-row w-full">
                        
                        <span class="ml-4 w-full text-bold text-lg font-bold underline"> DESCONTO: </span>
                        <div class="vx-row w-full mt-4 ml-4 justify-between">
                            <div class="vx-row w-full sm:w-full md:w-6/12 lg:w-6/12 xl:w-6/12">
                                <div class="vx-col w-1/12 mt-8">
                                    <vs-radio v-model="discount.checked" :vs-value="0" :disabled="(maxTotalToPay != manualTotalValue && isPayingAll)"/>
                                </div>
                                <div class="vx-col w-10/12">
                                    <span> Porcentagem </span>
                                    <currency-input 
                                        :disabled="discount.checked == 1 || (maxTotalToPay != manualTotalValue && isPayingAll)"
                                        :distraction-free="{ hideCurrencySymbol : false }"
                                        :auto-decimal-mode="true"
                                        :currency="{suffix: '%'}"
                                        :allow-negative="false"
                                        class="vs-inputx vs-input--input normal hasValue danger"
                                        v-model="discount.percent" 
                                        @change="(val) => val > 100 ? discount.percent = 100 : 0"/>
                                    <!-- <vs-input  :disabled="discount.checked == 1" v-model.number="discount.percent" class="w-full"  /> -->
                                </div>
                                <!-- <span class="mt-6 ml-2 font-bold" style="font-size: 28px">%</span> -->
                            </div>

                            <div class="vx-row w-full sm:w-full md:w-6/12 lg:w-6/12 xl:w-6/12">
                                <div class="vx-col w-1/12 mt-8">
                                    <vs-radio v-model="discount.checked" :vs-value="1" :disabled="(maxTotalToPay != manualTotalValue && isPayingAll)"/>
                                </div>
                                <div class="vx-col w-10/12" >
                                    <span > Quantia </span>
                                    <currency-input 
                                        :disabled="discount.checked == 0 || (maxTotalToPay != manualTotalValue && isPayingAll)"
                                        :distraction-free="{ hideCurrencySymbol : false }"
                                        :auto-decimal-mode="true"
                                        :currency="{prefix: 'R$ '}"
                                        :allow-negative="false"
                                        class="vs-inputx vs-input--input normal hasValue danger"
                                        v-model="discount.money"
                                        @change="val => val > maxTotalDiscount ? discount.money = maxTotalDiscount : 0" /> 
                                </div>
                                <!-- <span class="ml-2 font-bold" style="font-size: 28px">$</span> -->
                            </div>
                        </div>
                    </div>

                    <vs-divider border-style="dashed" class="mt-6 shadow">  </vs-divider>

                    <div class="flex w-full ">
                        <div class="flex w-full items-center justify-center">
                            <div class="w-4/12 text-right">
                                <span class="font-bold">TOTAL:</span><br/>
                                <template v-if="isPayingAll && !isDelivery">
                                    <currency-input 
                                        @change="(val) => onChangeManualTotalValue(val)"
                                        :disabled="!isPayingAll || totalDiscount > 0"
                                        :distraction-free="{ hideCurrencySymbol : false }"
                                        :auto-decimal-mode="true"
                                        :currency="{prefix: 'R$ '}"
                                        class="vs-inputx vs-input--input normal danger w-10/12 h-10"
                                        v-model="manualTotalValue" />
                                </template>
                                <span v-else class="text-2xl">{{ totalToPayPlusOthers | currency }}</span>
                            </div>

                            <div class="w-1/12 ml-6 mr-8">
                                <img src="@/assets/images/payment/money-bag.png" width="50"  />
                            </div>
                            
                            <div class="w-4/12">
                                <span class="font-bold">A PAGAR:</span><br/>
                                <span class="text-2xl" :class="{'text-danger font-bold' : (totalSelectedToPay).toFixed(2) != totalToPayPlusOthers.toFixed(2)}" v-if="windowWidth > 480">
                                    R$
                                    <number
                                        ref="totalToPayPlusOthers"
                                        :to="totalToPayPlusOthers"
                                        :format="(number) => number.toFixed(2).replace('.', ',')"
                                        :duration="0.1"
                                        easing="Power1.easeOut"/>
                                </span>

                                <span v-else class="text-2xl" 
                                    :class="{'text-danger font-bold' : (totalSelectedToPay).toFixed(2) != totalToPayPlusOthers.toFixed(2)}"> 
                                    {{ totalToPayPlusOthers | currency }}
                                </span>
                            </div>
                        </div>
                    </div>  
                </div>
            </div>

            <vs-divider border-style="dashed" />

            <div class="flex">
               
                <vs-button 
                    :disabled="(totalSelectedToPay.toFixed(2) != totalToPayPlusOthers.toFixed(2) && !isPayingAll) || 
                               (totalSelectedToPay == 0 || parseInt((totalSelectedToPay).toFixed(2).replace('.', '')) < parseInt(totalToPayPlusOthers.toFixed(2).replace('.', '')) && !isPayingAll) ||
                               (parseFloat((totalSelectedToPay).toFixed(2).replace('.', '')) < parseFloat((manualTotalValue - totalDiscount).toFixed(2).replace('.', '')) && isPayingAll) ||
                               (parseFloat((totalSelectedToPay).toFixed(2).replace('.', '')) != parseFloat((totalToPayPlusOthers).toFixed(2).replace('.', '')) )"
                               
                    class="w-full" 
                    type="relief" 
                    size="large" 
                    @click="payBillOrders" 
                    id="confirmPayment"> 
                        {{ windowWidth > 480 ? 'CONFIRMAR PAGAMENTO' : 'CONFIRMAR' }} 
                </vs-button>
            </div>

        </a-modal>
    </div>
</template>

<script>
import { httpsCallable } from "@/firebase/functions";
import VueInputCalculator from 'vue-input-calculator'
import { transformTaxes } from '@/components/taxes/Taxes.js'
import _misc from "@/assets/utils/misc.js"

export default {
    components : {
        VueInputCalculator
    },

    props : {
        billId: {
            // required : true,
            type: String
        },
        ordersToBePay: {
            required: true,
            type: Array
        },
        usersIdToBePay : {
            required : false,
            type : Object
        },
        visible: {
            required: true,
            type: Boolean
        },
        isPayingAll : {
            required: false,
            type: Boolean
        },
        totalToPay : {
            required : false,
            type : Number
        },
        totalBillValue : {
            required : false,
            type : Number
        },
        totalPaid : {
            required : false,
            type : Number
        },
        taxes : {
            required : false,
            type: Object
        },
        standalonePayment : {
            required : false,
            type: Number
        },
        taxesValue : {
            required : false,
            type: Number
        },
        isDelivery : {
            required : false,
            type: Boolean
        },
        discountValue : {
            required : false,
            type: Number
        }
    },

    data () {
        return {
            manualTotalValue : 0,
            discount : {
                checked : 0,
                percent : 0,
                money : 0
            },
            methods : [
                {
                    type: 'money',
                    selected : false,
                    value : 0,
                },
                {
                    type: 'card_credit',
                    selected : false,
                    value : 0
                },
                {
                    type: 'card_debit',
                    selected : false,
                    value : 0
                },
                {
                    type: 'picpay',
                    selected : false,
                    value : 0
                },
            ],
            changedValManually : false,
            type : 'card_debit',
            isActive : false,
            transformedTaxes : [],
            formatMoney: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
                masked: false
            },
        }
    },

    mounted () {
        // this.$message.config({ top: '80px'})
    },

    watch : {
        discount : {
            handler(newVal) {
                if(newVal.checked == 0)
                    this.$set(this.discount, 'money', 0)
                else
                    this.$set(this.discount, 'percent', 0)

                if(this.totalDiscount > 0) {
                    this.manualTotalValue = this.maxTotalToPay
                }
            },
            deep : true
        },

        manualTotalValue () {
            if(this.isPayingAll) {
                if(this.maxTotalToPay != this.manualTotalValue) {
                    this.$set(this.discount, 'money', 0)
                    this.$set(this.discount, 'percent', 0)
                }

                this.transformedTaxes = transformTaxes(this.taxes, this.manualTotalValue, this.discountValue)
            }
        },
        emmitNfce: {
            get () {
                return localStorage['emmitNfce'] || false;
            },
            set (value) {
                localStorage['emmitNfce'] = value;
            }
        },
        methods : {

            handler (newVal, oldVal, c) {
                newVal.forEach((method, i) => {
                    if(method.value == null) {
                        this.$set(this.methods[i], 'value', 0)
                    } 

                    const qtySelectedMethods = this.getQtySelectedMethods()
                    if(!this.changedValManually) {
                        if(qtySelectedMethods == 1 && method.selected) {
                            let calc = parseFloat((this.manualTotalValue + this.totalTaxesToPay - this.totalDiscount).toFixed(2))
                            if(!this.isPayingAll)
                                calc = parseFloat((this.totalToPayPlusOthers).toFixed(2))

                            this.$set(this.methods[i], 'value', calc)
                            this.changedValManually = true
                        }
                    }

                    if(qtySelectedMethods == 0)
                        this.changedValManually = false
                    
                    if(!method.selected) {
                        this.$set(this.methods[i], 'value', 0)
                    }
                })
            },
            deep : true
        },

        visible (newVal) {
            this.manualTotalValue = this.maxTotalToPay
            this.$set(this.discount, 'percent', 0)
            this.$set(this.discount, 'money', 0)
            
            if(!this.isPayingAll) {
                if(parseInt(this.totalToPay.toFixed(2).replace('.', '')) > parseInt(this.totalBillValue - this.totalPaid).toFixed(2).replace('.', '')) { 
                    this.transformedTaxes = transformTaxes(this.taxes, this.maxTotalToPay, this.discountValue)
                } else {
                    this.transformedTaxes = transformTaxes(this.taxes, this.totalToPay, this.discountValue)
                }
            }
            else {
                this.transformedTaxes = transformTaxes(this.taxes, this.manualTotalValue, this.discountValue)    
            }
            this.isActive = this.visible
        },

        isActive (newVal) {
            this.methods.forEach((method, i) => {
                this.$set(this.methods[i], 'selected', false)
            })
            this.$emit('close', newVal)
        }
    },

    computed : {
        maxTotalDiscount () {
            let totalToPay = this.totalToPay

            if(this.totalToPay) {
                if(parseInt(this.totalToPay.toFixed(2).replace('.', '')) > parseInt(this.totalBillValue - this.totalPaid).toFixed(2).replace('.', '')) {
                    totalToPay = this.totalBillValue - this.totalPaid - this.discountValue
                }
                if(this.isPayingAll) {
                    totalToPay = this.manualTotalValue
                }
            }

            return totalToPay
        },

        totalDiscount () {
            // let totalToPay = this.totalToPay - this.standalonePayment
            let totalToPay = this.maxTotalDiscount
            
            if(parseInt(this.totalToPay.toFixed(2).replace('.', '')) > parseInt(this.totalBillValue - this.totalPaid).toFixed(2).replace('.', '')) {
                totalToPay = this.totalBillValue - this.totalPaid - this.discountValue
            }

            if(this.discount.checked == 0) 
                return _misc.truncateDecimals((totalToPay * this.discount.percent) / 100)
            else
                return this.discount.money
        },

        totalTaxesToPay () {
            let total = 0
            let totalToPay = this.totalToPay;
            
            if(this.totalToPay) {
                if(parseInt(this.totalToPay.toFixed(2).replace('.', '')) > parseInt(this.totalBillValue - this.totalPaid).toFixed(2).replace('.', '')) {
                    totalToPay = this.maxTotalToPay
                }
                if(this.isPayingAll) {
                    totalToPay = this.manualTotalValue
                }
            }

            this.transformedTaxes.forEach(a => {
                if(a.enabled){
                    if(a.name == 'percentage') {
                        total += _misc.truncateDecimals((a.value * totalToPay) / 100)
                    }
                }
            })

            return _misc.truncateDecimals(total)
        },

        totalSelectedToPay () {
            let total = 0
            this.methods.forEach(method => {
                if(method.selected && method.value)
                    total += parseFloat(method.value)
            })
            
            return parseFloat(total)
        },

        totalToPayPlusOthers () {
            if(this.isPayingAll){
                return this.manualTotalValue + this.totalTaxesToPay - this.totalDiscount
            }else {
                if(parseInt(this.totalToPay.toFixed(2).replace('.', '')) > parseInt(this.totalBillValue - this.totalPaid).toFixed(2).replace('.', '')) 
                    return this.totalBillValue - this.totalPaid - this.discountValue + this.totalTaxesToPay - this.totalDiscount

                return this.totalToPay + this.totalTaxesToPay - this.totalDiscount
            }
        },

        maxTotalToPay () {
            return parseFloat((this.totalBillValue - this.discountValue - this.totalPaid ).toFixed(2))
        },

        windowWidth() {
            return this.$store.state.windowWidth
        },

        isStandalonePayment () {
            return this.manualTotalValue !== this.maxTotalToPay;
        }
    },
    
    methods : {
        onChangeManualTotalValue(val) {
            if(val == null) 
                this.manualTotalValue = this.maxTotalToPay

            if(parseInt((val).toFixed(2).replace('.', '')) > parseInt((this.maxTotalToPay).toFixed(2).replace('.', ''))) {
                this.manualTotalValue = this.maxTotalToPay
            }
        },

        getQtySelectedMethods () {
            let qty = 0;
            this.methods.forEach(method => {
                if(method.selected)
                    qty++
            })

            return qty
        },

        async payBillOrders () {
            let companyId = this.$store.getters.getCompanyID
            let setOrdersAsPaid = httpsCallable('setOrdersAsPaid')

            try {
                let billAutoClosed = this.isPayingAll ? 'A conta foi fechada automaticamente!' : ''
                if (this.ordersToBePay.length == 0 && !this.isPayingAll) throw new Error('Nenhum pedido foi selecionado para ser pago!')
                if (this.totalSelectedToPay.toFixed(2) != this.totalToPayPlusOthers.toFixed(2) && !this.isPayingAll) throw new Error('O valor do pagamento está incorreto!')

                this.$vs.loading()

                let arrMethods = []
                this.methods.forEach(method => {
                    if(method.selected && method.value) {
                        arrMethods.push(method)
                    }
                })

                let taxes = { }
                this.transformedTaxes.forEach(tax => {                    
                    const totalToPay = this.isPayingAll ? this.manualTotalValue : this.totalToPayPlusOthers - this.totalTaxesToPay
                    if(tax.enabled) {
                        const taxValue = tax.name == 'percentage' ? tax.calculatedValue : 0
                        taxes[tax.name] = { value : taxValue }
                    }
                })

                await setOrdersAsPaid({
                    companyId: companyId, 
                    billId : this.billId,
                    methods: arrMethods,
                    userOrders : this.isStandalonePayment ? null : this.usersIdToBePay,
                    taxes : taxes,
                    discount : { 
                        absolute : { 
                            value : this.totalDiscount
                            } 
                        },
                    client : {}
                })

                this.$success({
                    zIndex: 9999999,
                    title: 'Sucesso!',
                    content: `Pagamento realizado com sucesso.`
                })
                
                this.isActive = false
            } catch (err) {
                this.$error({
                    zIndex : 9999999,
                    title: 'Erro ao tentar efetuar pagamento',
                    content: `${err.message}`
                })
            } finally {
                this.$vs.loading.close()
            }
        }
    }
}
</script>

<style lang="less">
    .notSelected {
        opacity: 0.6;
    }
    .arrowTotalToPay {
        position: relative; 
        top: -2px;
    }
</style>